import { SET_PREVIOUSLY_ORDERED_DATA } from './actions'
import { SetPreviouslyOrderedDataAction } from './interfaces'

const initialState: State.PreviouslyOrdered = {
  timestamp: null,
  designConceptId: null,
}

export function reducer(state: State.PreviouslyOrdered = initialState, action: SetPreviouslyOrderedDataAction): State.PreviouslyOrdered {
  switch (action.type) {
    case SET_PREVIOUSLY_ORDERED_DATA:
      return {
        ...state,
        timestamp: action.payload.timestamp,
        designConceptId: action.payload.designConceptId,
      }
    default:
      return state
  }
}
